import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useLang } from "@/contexts/LangContext";
import { PawPrint, CheckCircle, XCircle } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) {
      setState("error");
      setErr("Missing token");
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        await api.get(`/auth/verify-email`, { params: { token } });
        if (!cancelled) setState("ok");
      } catch (e) {
        if (!cancelled) {
          setState("error");
          setErr(formatApiError(e));
        }
      }
    })();
    return () => { cancelled = true; };
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-pf-bg p-6">
      <div className="pf-card max-w-md w-full p-8 space-y-4 text-center">
        <div className="mx-auto h-12 w-12 rounded-lg bg-pf-primary text-white grid place-items-center">
          <PawPrint size={22} weight="fill" />
        </div>

        {state === "verifying" && (
          <div className="text-pf-text-secondary" data-testid="verify-email-verifying">
            {t("verifyingEmail")}
          </div>
        )}

        {state === "ok" && (
          <>
            <div className="mx-auto text-pf-primary">
              <CheckCircle size={40} weight="fill" />
            </div>
            <h1 className="font-display text-2xl font-bold text-pf-text" data-testid="verify-email-ok">
              {t("emailVerifiedTitle")}
            </h1>
            <p className="text-sm text-pf-text-secondary">{t("emailVerifiedBody")}</p>
            <button onClick={() => navigate("/login")} className="pf-btn-primary w-full justify-center">
              {t("backToLogin")}
            </button>
          </>
        )}

        {state === "error" && (
          <>
            <div className="mx-auto text-pf-danger">
              <XCircle size={40} weight="fill" />
            </div>
            <h1 className="font-display text-2xl font-bold text-pf-text" data-testid="verify-email-error">
              {t("emailVerifyFailedTitle")}
            </h1>
            <p className="text-sm text-pf-text-secondary">{err}</p>
            <button onClick={() => navigate("/login")} className="pf-btn-primary w-full justify-center">
              {t("backToLogin")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
